export default {"src":"/_next/static/media/instagram-social.cfc98d62.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};